// Mini Carousels
(function() {
    "use strict";
    const carouselToggles = document.querySelectorAll('.js-stripe-mini-carousel-toggle');
    const carouselSplashImage = document.querySelector('.js-stripe-mini-carousel-splash');
    const carousel = document.querySelector('.js-stripe-mini-carousel');
    if (carouselToggles && carouselSplashImage && carousel) {
        function handleInitCarousel() {
            [...carouselToggles].forEach(carouselToggle => {
                // Hide both toggle buttons
                carouselToggle.classList.add('d-none');
                carouselToggle.classList.add('d-lg-none');
                // Hide splash image
                carouselSplashImage.classList.add('d-none');
                // Show carousel
                carousel.classList.remove('d-none');
            });
        }

        [...carouselToggles].forEach(carouselToggle => {
            carouselToggle.addEventListener('click', handleInitCarousel);
        });
    }
})();
